import {alertConstants, appConstants} from '../_constants';
import {initialState} from "../_store";

export function azmanPayment(state=initialState.azmanPayment, action) {
    switch (action.type) {
        case appConstants.AZMAN_PAYMENT_SUCCESS:
            return Object.assign({}, state, action.azman);
        case alertConstants.ERROR:
            return action.message;
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/azman.reducer.js